import { useQuery } from 'react-query'
import { getRelayStatus, RelayStatusResponse } from '../../services/dataAPI'

export default function useRelayStatus(deviceId?: string) {
  const relayStatusQuery = useQuery<RelayStatusResponse>({
    queryKey: ['relay-status', deviceId],
    queryFn: () => getRelayStatus(deviceId as string),
    enabled: Boolean(deviceId),
    refetchInterval: 30000,
  })

  return { relayStatusQuery }
}
